export const levelTypes = {
    LEVEL: 'LEVEL',
    LEVEL_HIDDEN: 'LEVEL_HIDDEN',
};
export function isHiddenLevel(type) {
    return levelTypes.LEVEL_HIDDEN === type;
}
